/* eslint-disable func-names, max-len */
const $tabs = $('.js-tabs .tabs');

if ($tabs.length) {
  const self = {
    initialise() {
      if ($(window).innerWidth() > 767) {
        // on page load add active to first tab
        const $firstTab = $('.tabs li').first();
        $firstTab.addClass('active-tab');
        $('.tab-content-area .tab-content').first().show();
        $('.tab-content-area .tab-content').first().addClass('active');
      }

      $('.js-tabs .tabs li').click(function () {
        if ($(this).hasClass('active-tab')) {
          return false;
        }

        $('.tab-content-area .tab-content').hide();
        $('.js-tabs .tabs li').removeClass('active-tab');
        const indexOfTab = $(this).index();
        $(`.tab-content-area .tab-content:eq(${indexOfTab})`).show();

        $('.tab-content-area .tab-content').removeClass('active');
        $(`.tab-content-area .tab-content:eq(${indexOfTab})`).addClass('active');

        $(this).addClass('active-tab');
        return false;
      });

      $('.tab-content-area .mob-tab').click(function () {
        if ($(this).hasClass('active-tab')) {
          $(this).next('.tab-inner-content').hide();
          $(this).next('.tab-inner-content').removeClass('active');
          $(this).removeClass('active-tab');
          return false;
        }

        $(this).next('.tab-inner-content').show();
        $(this).next('.tab-inner-content').addClass('active');
        $(this).addClass('active-tab');
        return false;
      });

      if ($(window).innerWidth() > 767) {
        $('body').addClass('desktop');
      } else {
        $('body').addClass('mobile');
      }

      $(window).resize(() => {
        if ($(window).innerWidth() > 767) {
          // if body has class of mobile when in desktop sizes, remove it
          if ($('body').hasClass('mobile')) {
            $('body').removeClass('mobile');
            $('.tab-content-area .tab-inner-content').removeAttr('style');
          }

          // if body has class of desktop, then it is just a desktop resize - do nothing
          if ($('body').hasClass('desktop')) {
            // empty
          } else {
            $('body').addClass('desktop');
            $('.tab-content-area .accordion-title').removeClass('active-tab');
            $('.tab-content-area .tab-content').hide();
            $('.tabs li:first-child').addClass('active-tab');

            $('.tab-content-area .tab-content:first').show();
            $('.tab-content-area .tab-content:first').addClass('active');
          }
        } else {
          // if body has class of desktop when in mobile sizes, remove it
          if ($('body').hasClass('desktop')) {
            $('body').removeClass('desktop');
            $('.tab-content-area .tab-content').removeAttr('style');
          }

          // if body has class of mobile, then it is just a mobile resize - do nothing
          if ($('body').hasClass('mobile')) {
            // empty
          } else {
            $('body').addClass('mobile');
            $('.tabs li').removeClass('active-tab');
            $('.tab-content-area .tab-content').hide();
            $('.tab-content-area .tab-content').removeAttr('style');
          }
        }
      });
    },
  };

  self.initialise();
}
